import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE
const getToken = () => localStorage.getItem('cms_token') || localStorage.getItem('boxiaotu_token') || ''
const authHeaders = () => ({ 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` })

// v3b (2026-09-01 小套接管): 实战营 3 套新合同模板在线渲染预览
// 先用空变量探测必填项，再把缺失项填占位符，出"填空式"全文预览（归档时才真正填写）
const TEMPLATE_API = '/cms/api/contracts/templates'
const openTemplatePreview = async (templateId) => {
  try {
    const call = (variables) => fetch(`${TEMPLATE_API}/${templateId}/render`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ variables })
    }).then(r => r.json())
    let j = await call({})
    if (!j.success && j.data && Array.isArray(j.data.missing) && j.data.missing.length) {
      const vars = {}
      j.data.missing.forEach(k => { vars[k] = '＿＿＿＿' })
      j = await call(vars)
    }
    if (j.success && j.data && j.data.content) {
      const w = window.open('', '_blank')
      if (!w) { alert('浏览器拦截了新窗口，请允许弹出窗口后重试'); return }
      w.document.title = j.data.title || templateId
      const style = w.document.createElement('style')
      style.textContent = 'body{margin:0;background:#f7f7f2}pre{white-space:pre-wrap;font-family:Georgia,"Songti SC",SimSun,serif;font-size:15px;line-height:2;max-width:780px;margin:36px auto;padding:0 24px;color:#222}'
      w.document.head.appendChild(style)
      const pre = w.document.createElement('pre')
      pre.textContent = j.data.content
      w.document.body.appendChild(pre)
    } else {
      alert(j.error || '模板渲染失败')
    }
  } catch (e) {
    alert('模板渲染失败：' + e.message)
  }
}

// 状态标签映射
const STATUS_LABELS = {
  draft: '草稿',
  pending_sign: '待签署',
  pending_approval: '待审批',
  signed: '已签署',
  approved: '已通过',
  rejected: '已拒绝',
  cancelled: '已取消'
}
const STATUS_COLORS = {
  draft: '#d9d9d9',
  pending_sign: '#faad14',
  pending_approval: '#1890ff',
  signed: '#52c41a',
  approved: '#389e0d',
  rejected: '#f5222d',
  cancelled: '#999'
}
const TYPE_LABELS = {
  saas_upgrade: 'SaaS升级申请',
  institution: '机构合作合同',
  partner_apply: '合作申请',
  agent: '代理合同',
  other: '其他'
}

const APPLY_TYPES = {
  workshop_enroll_v1: '企业大脑装机陪跑服务协议',
  level4_private_v1: '企业大脑服务层·私有部署年度服务合同',
  skill_license_v1: 'SKILL定制成果授权使用协议',
  sidonghui_v1: '企业大脑服务层·服务商孵化与席位协议',
  saas_upgrade: 'SaaS软件升级',
  course_cooperation: '课程合作（七彩故事工坊等）',
  regional_agent: '区域代理',
  other: '其他合作'
}

export default function Contracts() {
  const [contracts, setContracts] = useState([])
  const [loading, setLoading] = useState(true)
  const [stats, setStats] = useState({ total: 0, pending: 0, signed: 0, approved: 0 })
  const [filter, setFilter] = useState('all')
  const [typeFilter, setTypeFilter] = useState('all')
  const [detailContract, setDetailContract] = useState(null)
  const [contractModal, setContractModal] = useState({ open: false, mode: '', data: null })

  useEffect(() => { fetchContracts() }, [filter, typeFilter])

  const fetchContracts = () => {
    setLoading(true)
    fetch(`${API}/contracts`, { headers: authHeaders() })
      .then(r => r.json())
      .then(data => {
        if (data.success) {
          let list = data.data || []
          // 状态筛选
          if (filter !== 'all') list = list.filter(c => c.status === filter)
          // 类型筛选
          if (typeFilter !== 'all') list = list.filter(c => c.type === typeFilter)
          setContracts(list)
          // 统计
          setStats({
            total: data.total || list.length,
            pending: (data.data || []).filter(c => c.status === 'pending_approval' || c.status === 'pending_sign').length,
            signed: (data.data || []).filter(c => c.status === 'signed').length,
            approved: (data.data || []).filter(c => c.status === 'approved').length,
          })
        }
      })
      .finally(() => setLoading(false))
  }

  const handleApprove = async (id) => {
    if (!confirm('确认通过此合同？')) return
    try {
      const r = await fetch(`${API}/contracts/${id}`, {
        method: 'PUT',
        headers: authHeaders(),
        body: JSON.stringify({ status: 'approved' })
      })
      const data = await r.json()
      if (data.success) { fetchContracts(); setDetailContract(null) }
      else alert(data.error || '操作失败')
    } catch (e) { alert('网络错误') }
  }

  const handleReject = async (id) => {
    const reason = prompt('请输入拒绝原因：')
    if (!reason) return
    try {
      const r = await fetch(`${API}/contracts/${id}`, {
        method: 'PUT',
        headers: authHeaders(),
        body: JSON.stringify({ status: 'rejected', reject_reason: reason })
      })
      const data = await r.json()
      if (data.success) { fetchContracts(); setDetailContract(null) }
      else alert(data.error || '操作失败')
    } catch (e) { alert('网络错误') }
  }

  const handleMarkSigned = async (id) => {
    if (!confirm('确认将本合同标记为"已签署"？')) return
    try {
      const r = await fetch(`${API}/contracts/${id}`, {
        method: 'PUT',
        headers: authHeaders(),
        body: JSON.stringify({ status: 'signed' })
      })
      const data = await r.json()
      if (data.success) { fetchContracts(); setDetailContract(null) }
      else alert(data.error || '操作失败')
    } catch (e) { alert('网络错误') }
  }

  const formatDate = (d) => {
    if (!d) return '-'
    return d.replace('T', ' ').substring(0, 16)
  }

  const formatMoney = (v) => {
    if (!v || v === 0) return '-'
    return `¥${parseFloat(v).toLocaleString('zh-CN', { minimumFractionDigits: 2 })}`
  }

  // ============================================================
  // 合同详情弹窗
  // ============================================================
  const ContractDetail = ({ contract, onClose }) => {
    if (!contract) return null
    const canApprove = contract.status === 'pending_approval' || contract.status === 'signed'
    const canReject = contract.status === 'pending_approval' || contract.status === 'pending_sign'
    const canMarkSigned = contract.status === 'pending_sign'

    return (
      <div style={{
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 9999,
        background: 'rgba(0,0,0,0.45)', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 20
      }} onClick={onClose}>
        <div style={{
          background: '#fff', borderRadius: 12, maxWidth: 640, width: '100%', maxHeight: '85vh',
          overflow: 'auto', padding: 24
        }} onClick={e => e.stopPropagation()}>
          {/* 头部 */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16 }}>
            <div>
              <h2 style={{ margin: '0 0 4px', fontSize: 18, color: '#333' }}>
                {TYPE_LABELS[contract.type] || contract.type || '合同'}
                <span style={{ fontSize: 13, fontWeight: 400, color: '#999', marginLeft: 8 }}>{contract.contract_no}</span>
              </h2>
              <span style={{
                display: 'inline-block', padding: '2px 10px', borderRadius: 10,
                fontSize: 12, fontWeight: 600, color: '#fff',
                background: STATUS_COLORS[contract.status] || '#d9d9d9'
              }}>
                {STATUS_LABELS[contract.status] || contract.status}
              </span>
            </div>
            <button onClick={onClose} style={{
              border: 'none', background: '#f5f5f5', borderRadius: 6, padding: '4px 10px',
              cursor: 'pointer', fontSize: 16, color: '#999'
            }}>✕</button>
          </div>

          <div style={{
            background: '#fafafa', borderRadius: 8, padding: 16, marginBottom: 16,
            display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, fontSize: 13
          }}>
            <div><strong style={{ color: '#666' }}>机构：</strong>{contract.institution_name || contract.institution_id}</div>
            {contract.type === 'partner_apply' && (
              <div><strong style={{ color: '#666' }}>合作类型：</strong>{APPLY_TYPES[contract.plan_type] || contract.plan_type || '-'}</div>
            )}
            <div><strong style={{ color: '#666' }}>公司名称：</strong>{contract.company_name || '-'}</div>
            <div><strong style={{ color: '#666' }}>统一社会信用代码：</strong>{contract.credit_code || '-'}</div>
            <div><strong style={{ color: '#666' }}>法定代表人：</strong>{contract.legal_person || '-'}</div>
            <div><strong style={{ color: '#666' }}>联系人：</strong>{contract.contact_name || '-'}</div>
            <div><strong style={{ color: '#666' }}>联系电话：</strong>{contract.contact_phone || '-'}</div>
            <div><strong style={{ color: '#666' }}>联系邮箱：</strong>{contract.contact_email || '-'}</div>
          </div>

          {/* SaaS升级申请特有 */}
          {contract.type === 'saas_upgrade' && (
            <div style={{
              background: '#fff7e6', borderRadius: 8, padding: 16, marginBottom: 16,
              display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, fontSize: 13
            }}>
              <div><strong style={{ color: '#d46b08' }}>目标版本：</strong>{contract.plan_type || '-'}</div>
              <div><strong style={{ color: '#d46b08' }}>合同金额：</strong>{formatMoney(contract.plan_amount)}</div>
              <div><strong style={{ color: '#d46b08' }}>定金：</strong>{formatMoney(contract.deposit_amount)}</div>
              <div><strong style={{ color: '#d46b08' }}>佣金比例：</strong>
                {contract.commission_rate ? `${contract.commission_rate}%` : '-'}
              </div>
            </div>
          )}

          {/* 合同内容 */}
          {contract.content && (
            <>
              <div style={{ fontSize: 14, fontWeight: 600, color: '#333', marginBottom: 8 }}>📄 合同内容</div>
              <div style={{
                background: '#f5f5f5', borderRadius: 8, padding: 16, fontSize: 13,
                whiteSpace: 'pre-wrap', color: '#555', marginBottom: 16
              }}>
                {contract.content}
              </div>
            </>
          )}

          {/* 备注 */}
          {contract.remarks && (
            <>
              <div style={{ fontSize: 14, fontWeight: 600, color: '#333', marginBottom: 8 }}>📝 备注</div>
              <div style={{ background: '#f5f5f5', borderRadius: 8, padding: 16, fontSize: 13, color: '#555', marginBottom: 16 }}>
                {contract.remarks}
              </div>
            </>
          )}

          {/* 拒绝原因 */}
          {contract.reject_reason && (
            <div style={{
              background: '#fff1f0', border: '1px solid #ffa39e', borderRadius: 8, padding: 16, marginBottom: 16
            }}>
              <div style={{ fontSize: 13, fontWeight: 600, color: '#cf1322', marginBottom: 4 }}>❌ 拒绝原因</div>
              <div style={{ fontSize: 13, color: '#555' }}>{contract.reject_reason}</div>
            </div>
          )}

          {/* 时间线 */}
          <div style={{
            background: '#fafafa', borderRadius: 8, padding: 16, marginBottom: 16,
            fontSize: 12, color: '#999', display: 'flex', gap: 20, flexWrap: 'wrap'
          }}>
            <span>📅 创建：{formatDate(contract.created_at)}</span>
            {contract.signed_at && <span>✍️ 签署：{formatDate(contract.signed_at)}</span>}
            {contract.approved_at && <span>✅ 通过：{formatDate(contract.approved_at)}</span>}
          </div>

          {/* 📎 合同文件 */}
          <div style={{
            background: '#fafafa', borderRadius: 8, padding: 16, marginBottom: 16
          }}>
            <div style={{ fontSize: 14, fontWeight: 600, color: '#333', marginBottom: 12 }}>📎 合同文件</div>

            {/* 机构扫描件 */}
            <div style={{ marginBottom: 12 }}>
              <div style={{ fontSize: 13, color: '#666', marginBottom: 6 }}>📄 机构扫描件（甲方）</div>
              <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                {contract.file_org ? (
                  <>
                    <a href={contract.file_org.startsWith('http') ? contract.file_org : 'https://api.boxiaotu.cn' + contract.file_org}
                       target="_blank" rel="noopener noreferrer"
                       style={{
                         padding: '6px 14px', background: '#e6f7ff', border: '1px solid #91d5ff',
                         borderRadius: 6, fontSize: 13, color: '#1890ff', textDecoration: 'none',
                         display: 'inline-flex', alignItems: 'center', gap: 4
                       }}>
                      👁 查看/下载
                    </a>
                  </>
                ) : (
                  <span style={{ fontSize: 12, color: '#bbb' }}>尚未上传</span>
                )}
              </div>
            </div>

            {/* 总部盖章版 */}
            <div style={{ marginBottom: 12 }}>
              <div style={{ fontSize: 13, color: '#666', marginBottom: 6 }}>🏢 总部盖章版（乙方）</div>
              <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                {contract.file_hq ? (
                  <a href={contract.file_hq.startsWith('http') ? contract.file_hq : 'https://api.boxiaotu.cn' + contract.file_hq}
                     target="_blank" rel="noopener noreferrer"
                     style={{
                       padding: '6px 14px', background: '#fff7e6', border: '1px solid #ffd591',
                       borderRadius: 6, fontSize: 13, color: '#d46b08', textDecoration: 'none',
                       display: 'inline-flex', alignItems: 'center', gap: 4
                     }}>
                    👁 查看/下载
                  </a>
                ) : (
                  <span style={{ fontSize: 12, color: '#bbb' }}>尚未上传</span>
                )}
                {/* 总部上传按钮 — 仅当合同已签署或已通过时可上传 */}
                {(contract.status === 'signed' || contract.status === 'approved') && (
                  <label style={{
                    padding: '6px 14px', background: '#f6ffed', border: '1px solid #b7eb8f',
                    borderRadius: 6, fontSize: 13, color: '#52c41a', cursor: 'pointer',
                    display: 'inline-flex', alignItems: 'center', gap: 4
                  }}>
                    📤 上传盖章版
                    <input type="file" accept=".pdf,.jpg,.jpeg,.png" style={{ display: 'none' }}
                           onChange={async (e) => {
                             const file = e.target.files[0];
                             if (!file) return;
                             if (file.size > 20 * 1024 * 1024) { alert('文件大小不能超过20MB'); return; }
                             const fd = new FormData();
                             fd.append('file', file);
                             try {
                               const r = await fetch(API + '/contracts/' + contract.id + '/upload?role=hq', {
                                 method: 'POST',
                                 headers: { 'Authorization': 'Bearer ' + getToken() },
                                 body: fd
                               });
                               const d = await r.json();
                               if (d.success) {
                                 alert('上传成功！');
                                 onClose();  // 关闭并刷新
                                 fetchContracts();
                               } else {
                                 alert(d.error || '上传失败');
                               }
                             } catch(e) { alert('网络错误'); }
                           }} />
                  </label>
                )}
              </div>
            </div>
          </div>
          {/* 操作按钮 */}
          <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', borderTop: '1px solid #f0f0f0', paddingTop: 16 }}>
            {canMarkSigned && (
              <button onClick={() => handleMarkSigned(contract.id)} style={{
                padding: '8px 20px', border: '1px solid #52c41a', borderRadius: 6,
                background: '#f6ffed', color: '#52c41a', cursor: 'pointer', fontSize: 13
              }}>✍️ 标记已签署</button>
            )}
            {canReject && (
              <button onClick={() => handleReject(contract.id)} style={{
                padding: '8px 20px', border: '1px solid #f5222d', borderRadius: 6,
                background: '#fff', color: '#f5222d', cursor: 'pointer', fontSize: 13
              }}>❌ 拒绝</button>
            )}
            {canApprove && (
              <button onClick={() => handleApprove(contract.id)} style={{
                padding: '8px 20px', border: 'none', borderRadius: 6,
                background: 'linear-gradient(135deg, #52c41a, #389e0d)', color: '#fff',
                cursor: 'pointer', fontSize: 13, fontWeight: 600
              }}>✅ 通过合同</button>
            )}
          </div>
        </div>
      </div>
    )
  }

  // ============================================================
  // 新建合同弹窗
  // ============================================================
  const CreateContractModal = ({ onClose }) => {
    const [form, setForm] = useState({
      type: 'institution',
      institution_id: '',
      company_name: '', credit_code: '', legal_person: '',
      contact_name: '', contact_phone: '', contact_email: '',
      plan_type: '', plan_amount: '', deposit_amount: '', commission_rate: '',
      content: '', remarks: ''
    })
    const [saving, setSaving] = useState(false)
    const [institutions, setInstitutions] = useState([])

    useEffect(() => {
      fetch(`${API}/institutions`)
        .then(r => r.json())
        .then(data => {
          if (data.success) setInstitutions(data.data || [])
        })
        .catch(e => { console.error(e) })
    }, [])

    const handleSubmit = async () => {
      if (!form.type) { alert('请选择合同类型'); return }
      if (!form.institution_id) { alert('请选择机构'); return }
      setSaving(true)
      try {
        const r = await fetch(`${API}/contracts`, {
          method: 'POST',
          headers: authHeaders(),
          body: JSON.stringify({
            ...form,
            plan_amount: parseFloat(form.plan_amount) || 0,
            deposit_amount: parseFloat(form.deposit_amount) || 0,
            commission_rate: parseFloat(form.commission_rate) || 0
          })
        })
        const data = await r.json()
        if (data.success) {
          alert('合同创建成功！合同编号：' + data.data.contract_no)
          fetchContracts()
          onClose()
        } else {
          alert(data.error || '创建失败')
        }
      } catch (e) { alert('网络错误') }
      setSaving(false)
    }

    return (
      <div style={{
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 9999,
        background: 'rgba(0,0,0,0.45)', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 20
      }} onClick={onClose}>
        <div style={{
          background: '#fff', borderRadius: 12, maxWidth: 640, width: '100%', maxHeight: '85vh',
          overflow: 'auto', padding: 24
        }} onClick={e => e.stopPropagation()}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
            <h2 style={{ margin: 0, fontSize: 18, color: '#333' }}>📄 新建合同</h2>
            <button onClick={onClose} style={{
              border: 'none', background: '#f5f5f5', borderRadius: 6, padding: '4px 10px',
              cursor: 'pointer', fontSize: 16, color: '#999'
            }}>✕</button>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            {/* 合同类型 */}
            <div>
              <label style={{ fontSize: 12, color: '#666', marginBottom: 4, display: 'block' }}>合同类型 *</label>
              <select value={form.type} onChange={e => setForm({...form, type: e.target.value})} style={inputStyle}>
                <option value="institution">机构合作合同</option>
                <option value="saas_upgrade">SaaS升级申请</option>
                <option value="agent">代理合同</option>
                <option value="other">其他</option>
              </select>
            </div>
            {/* 机构 */}
            <div>
              <label style={{ fontSize: 12, color: '#666', marginBottom: 4, display: 'block' }}>机构/甲方 *</label>
              <select value={form.institution_id} onChange={e => setForm({...form, institution_id: e.target.value})} style={inputStyle}>
                <option value="">选择机构</option>
                {institutions.map(i => (
                  <option key={i.id} value={i.id}>{i.name}</option>
                ))}
              </select>
            </div>
            {/* 公司名称 */}
            <div>
              <label style={{ fontSize: 12, color: '#666', marginBottom: 4, display: 'block' }}>公司名称</label>
              <input value={form.company_name} onChange={e => setForm({...form, company_name: e.target.value})} style={inputStyle} placeholder="公司全称" />
            </div>
            {/* 信用代码 */}
            <div>
              <label style={{ fontSize: 12, color: '#666', marginBottom: 4, display: 'block' }}>统一社会信用代码</label>
              <input value={form.credit_code} onChange={e => setForm({...form, credit_code: e.target.value})} style={inputStyle} placeholder="18位代码" />
            </div>
            {/* 法人 */}
            <div>
              <label style={{ fontSize: 12, color: '#666', marginBottom: 4, display: 'block' }}>法定代表人</label>
              <input value={form.legal_person} onChange={e => setForm({...form, legal_person: e.target.value})} style={inputStyle} placeholder="姓名" />
            </div>
            {/* 联系人 */}
            <div>
              <label style={{ fontSize: 12, color: '#666', marginBottom: 4, display: 'block' }}>联系人</label>
              <input value={form.contact_name} onChange={e => setForm({...form, contact_name: e.target.value})} style={inputStyle} placeholder="姓名" />
            </div>
            {/* 联系电话 */}
            <div>
              <label style={{ fontSize: 12, color: '#666', marginBottom: 4, display: 'block' }}>联系电话</label>
              <input value={form.contact_phone} onChange={e => setForm({...form, contact_phone: e.target.value})} style={inputStyle} placeholder="手机号" />
            </div>
            {/* 邮箱 */}
            <div>
              <label style={{ fontSize: 12, color: '#666', marginBottom: 4, display: 'block' }}>联系邮箱</label>
              <input value={form.contact_email} onChange={e => setForm({...form, contact_email: e.target.value})} style={inputStyle} placeholder="邮箱地址" />
            </div>
            {/* 目标版本（SaaS升级时显示） */}
            {form.type === 'saas_upgrade' && (
              <>
                <div>
                  <label style={{ fontSize: 12, color: '#666', marginBottom: 4, display: 'block' }}>目标版本</label>
                  <select value={form.plan_type} onChange={e => setForm({...form, plan_type: e.target.value})} style={inputStyle}>
                    <option value="">选择版本</option>
                    <option value="pro">专业版（¥299/年）</option>
                    <option value="enterprise">企业版（¥999/年）</option>
                  </select>
                </div>
                <div>
                  <label style={{ fontSize: 12, color: '#666', marginBottom: 4, display: 'block' }}>合同金额</label>
                  <input value={form.plan_amount} onChange={e => setForm({...form, plan_amount: e.target.value})} style={inputStyle} placeholder="如 299" type="number" />
                </div>
                <div>
                  <label style={{ fontSize: 12, color: '#666', marginBottom: 4, display: 'block' }}>定金</label>
                  <input value={form.deposit_amount} onChange={e => setForm({...form, deposit_amount: e.target.value})} style={inputStyle} placeholder="如 100" type="number" />
                </div>
                <div>
                  <label style={{ fontSize: 12, color: '#666', marginBottom: 4, display: 'block' }}>佣金比例(%)</label>
                  <input value={form.commission_rate} onChange={e => setForm({...form, commission_rate: e.target.value})} style={inputStyle} placeholder="如 80" type="number" />
                </div>
              </>
            )}
          </div>

          {/* 合同内容（全宽） */}
          <div style={{ marginTop: 12 }}>
            <label style={{ fontSize: 12, color: '#666', marginBottom: 4, display: 'block' }}>合同内容 / 条款</label>
            <textarea value={form.content} onChange={e => setForm({...form, content: e.target.value})} style={{
              ...inputStyle, width: '100%', minHeight: 100, resize: 'vertical',
              fontFamily: 'monospace', fontSize: 12
            }} placeholder="合同详细条款/内容..." />
          </div>

          {/* 备注 */}
          <div style={{ marginTop: 12 }}>
            <label style={{ fontSize: 12, color: '#666', marginBottom: 4, display: 'block' }}>备注</label>
            <textarea value={form.remarks} onChange={e => setForm({...form, remarks: e.target.value})} style={{
              ...inputStyle, width: '100%', minHeight: 60, resize: 'vertical', fontSize: 13
            }} placeholder="内部备注..." />
          </div>

          <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 20, borderTop: '1px solid #f0f0f0', paddingTop: 16 }}>
            <button onClick={onClose} style={{
              padding: '8px 24px', border: '1px solid #d9d9d9', borderRadius: 6,
              background: '#fff', cursor: 'pointer', fontSize: 14
            }}>取消</button>
            <button onClick={handleSubmit} disabled={saving} style={{
              padding: '8px 24px', border: 'none', borderRadius: 6,
              background: saving ? '#d9d9d9' : 'linear-gradient(135deg, #1890ff, #096dd9)',
              color: '#fff', cursor: saving ? 'not-allowed' : 'pointer', fontSize: 14, fontWeight: 600
            }}>{saving ? '创建中...' : '创建合同'}</button>
          </div>
        </div>
      </div>
    )
  }

  const inputStyle = {
    width: '100%', padding: '8px 10px', border: '1px solid #d9d9d9', borderRadius: 6,
    fontSize: 13, outline: 'none', boxSizing: 'border-box', background: '#fff'
  }

  // ============================================================
  // 主渲染
  // ============================================================
  return (
    <div>
      {/* 统计卡片 */}
      <div style={{ display: 'flex', gap: 12, marginBottom: 20 }}>
        {[
          { label: '总合同数', value: stats.total, color: '#1890ff' },
          { label: '待处理', value: stats.pending, color: '#faad14' },
          { label: '已签署', value: stats.signed, color: '#52c41a' },
          { label: '已通过', value: stats.approved, color: '#389e0d' },
        ].map((s, i) => (
          <div key={i} style={{
            flex: 1, background: '#fff', borderRadius: 10, padding: '16px 20px',
            borderLeft: `3px solid ${s.color}`, boxShadow: '0 1px 4px rgba(0,0,0,0.04)'
          }}>
            <div style={{ fontSize: 24, fontWeight: 700, color: s.color }}>{s.value}</div>
            <div style={{ fontSize: 13, color: '#999', marginTop: 4 }}>{s.label}</div>
          </div>
        ))}
      </div>

      {/* ===== 合同模板预览区 ===== */}
      <div style={{ background: '#e6f7ff', border: '1px solid #91d5ff', borderRadius: '8px', padding: '16px 20px', marginBottom: '16px' }}>
        <div style={{ fontSize: '15px', fontWeight: 600, color: '#0050b3', marginBottom: '12px' }}>📄 标准合同模板</div>
        <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
          {[
            { name: '七彩故事工坊合作协议', file: 'boxiaotu_story_cooperation.html', desc: '¥298/年 含10次AI动画·机构分佣50%' },
            { name: 'SaaS软件升级服务协议', file: 'boxiaotu_saas_upgrade.html', desc: 'SaaS系统升级·数据迁移·专属服务' },
            { name: '区域代理合作协议', file: 'boxiaotu_regional_agent.html', desc: '地级市代理·¥49/单佣金' },
            { name: '总部推广员合作协议', file: 'boxiaotu_promoter.html', desc: '推广员·二级分佣·续费分成' }
          ].map(t => (
            <a key={t.file} href={'https://api.boxiaotu.cn/storage/contracts/' + t.file} target="_blank" rel="noopener noreferrer"
              style={{ display: 'block', background: '#fff', border: '1px solid #d9d9d9', borderRadius: '8px', padding: '12px 16px', textDecoration: 'none', color: '#333', minWidth: '200px', flex: '1' }}>
              <div style={{ fontSize: '14px', fontWeight: 600, marginBottom: '4px' }}>📋 {t.name}</div>
              <div style={{ fontSize: '12px', color: '#666' }}>{t.desc}</div>
              <div style={{ fontSize: '11px', color: '#1890ff', marginTop: '8px' }}>👁 预览 & 下载 →</div>
            </a>
          ))}
        </div>
        <div style={{ fontSize: '11px', color: '#999', marginTop: '8px' }}>点击合同模板在新标签页中打开PDF，右键可保存下载</div>
      </div>

      {/* ===== 实战营 3 套新合同模板（09-01 上线，在线渲染预览）===== */}
      <div style={{ background: '#f6ffed', border: '1px solid #b7eb8f', borderRadius: '8px', padding: '16px 20px', marginBottom: '16px' }}>
        <div style={{ fontSize: '15px', fontWeight: 600, color: '#389e0d', marginBottom: '4px' }}>🧾 实战营合同模板（2026-09-01 新增 · 在线渲染）</div>
        <div style={{ fontSize: '11px', color: '#999', marginBottom: '12px' }}>点击在线渲染全文预览（甲方信息为填空占位，正式归档时才填写）</div>
        <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
          {[
            { id: 'workshop_enroll_v1', name: '企业大脑装机陪跑服务协议', desc: '¥12000 装机陪跑 · 4位AI员工上岗 · 30天零调用全额退' },
            { id: 'level4_private_v1', name: '企业大脑服务层 · 私有部署年度服务合同', desc: '¥100000/年 · 含SLA附件兜底' },
            { id: 'skill_license_v1', name: 'SKILL 定制成果授权使用协议（实战营校友）', desc: '校友免费 · SKILL.md 知识产权授权' },
            { id: 'sidonghui_v1', name: '企业大脑服务层 · 服务商孵化与席位协议', desc: '服务商孵化与席位 · 长期合作' }
          ].map(t => (
            <a key={t.id} href="#!" onClick={(e) => { e.preventDefault(); openTemplatePreview(t.id) }}
              style={{ display: 'block', background: '#fff', border: '1px solid #d9d9d9', borderRadius: '8px', padding: '12px 16px', textDecoration: 'none', color: '#333', minWidth: '200px', flex: '1', cursor: 'pointer' }}>
              <div style={{ fontSize: '14px', fontWeight: 600, marginBottom: '4px' }}>🆕 {t.name}</div>
              <div style={{ fontSize: '12px', color: '#666' }}>{t.desc}</div>
              <div style={{ fontSize: '11px', color: '#52c41a', marginTop: '8px' }}>👁 在线渲染全文 →</div>
            </a>
          ))}
        </div>
      </div>

      {/* 筛选栏 */}
      <div style={{
        background: '#fff', borderRadius: 10, padding: 16, marginBottom: 16,
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        boxShadow: '0 1px 4px rgba(0,0,0,0.04)'
      }}>
        <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
          <span style={{ fontSize: 13, color: '#666' }}>状态：</span>
          <select value={filter} onChange={e => setFilter(e.target.value)} style={{
            padding: '6px 12px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 13
          }}>
            <option value="all">全部</option>
            {Object.entries(STATUS_LABELS).map(([k, v]) => (
              <option key={k} value={k}>{v}</option>
            ))}
          </select>
          <span style={{ fontSize: 13, color: '#666' }}>类型：</span>
          <select value={typeFilter} onChange={e => setTypeFilter(e.target.value)} style={{
            padding: '6px 12px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 13
          }}>
            <option value="all">全部</option>
            {Object.entries(TYPE_LABELS).map(([k, v]) => (
              <option key={k} value={k}>{v}</option>
            ))}
          </select>
        </div>
        <button onClick={() => setContractModal({ open: true, mode: 'create' })} style={{
          padding: '8px 20px', border: 'none', borderRadius: 6,
          background: 'linear-gradient(135deg, #1890ff, #096dd9)', color: '#fff',
          cursor: 'pointer', fontSize: 13, fontWeight: 600
        }}>+ 新建合同</button>
      </div>

      {/* 列表 */}
      {loading ? (
        <div style={{ textAlign: 'center', padding: 40, color: '#999', fontSize: 14 }}>加载中...</div>
      ) : contracts.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 60, color: '#ccc', fontSize: 14 }}>
          📭 暂无合同数据
        </div>
      ) : (
        <div style={{ background: '#fff', borderRadius: 10, overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.04)' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ background: '#fafafa', borderBottom: '1px solid #f0f0f0' }}>
                <th style={thStyle}>合同编号</th>
                <th style={thStyle}>类型</th>
                <th style={thStyle}>机构</th>
                <th style={thStyle}>联系人</th>
                <th style={thStyle}>金额</th>
                <th style={thStyle}>状态</th>
                <th style={thStyle}>创建时间</th>
                <th style={thStyle}>操作</th>
              </tr>
            </thead>
            <tbody>
              {contracts.map(c => (
                <tr key={c.id} style={{ borderBottom: '1px solid #f5f5f5', cursor: 'pointer' }}
                  onClick={() => setDetailContract(c)}>
                  <td style={tdStyle}><span style={{ color: '#1890ff', fontSize: 12 }}>{c.contract_no}</span></td>
                  <td style={tdStyle}>{TYPE_LABELS[c.type] || c.type}</td>
                  <td style={{ ...tdStyle, maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {c.institution_name || c.institution_id}
                  </td>
                  <td style={tdStyle}>{c.contact_name || '-'}</td>
                  <td style={tdStyle}>{formatMoney(c.plan_amount)}</td>
                  <td style={tdStyle}>
                    <span style={{
                      display: 'inline-block', padding: '2px 8px', borderRadius: 8,
                      fontSize: 11, fontWeight: 600, color: '#fff',
                      background: STATUS_COLORS[c.status] || '#d9d9d9'
                    }}>
                      {STATUS_LABELS[c.status] || c.status}
                    </span>
                  </td>
                  <td style={{ ...tdStyle, color: '#999' }}>{formatDate(c.created_at)}</td>
                  <td style={tdStyle}>
                    <span style={{ color: '#1890ff', fontSize: 12 }}>查看详情 →</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* 详情弹窗 */}
      {detailContract && (
        <ContractDetail contract={detailContract} onClose={() => setDetailContract(null)} />
      )}

      {/* 新建弹窗 */}
      {contractModal.open && contractModal.mode === 'create' && (
        <CreateContractModal onClose={() => setContractModal({ open: false, mode: '' })} />
      )}
    </div>
  )
}

const thStyle = {
  padding: '12px 14px', textAlign: 'left', fontSize: 12, fontWeight: 600, color: '#666'
}
const tdStyle = {
  padding: '12px 14px', color: '#333', fontSize: 13
}
